import { create } from 'zustand';
import { PaymentSummaryData, PaymentSuccessResponse } from '@/components/blocks/ChargeMember/types';
import { storeRegistry } from './storeRegistry';

// Define enum for charge member steps
export enum ChargeMemberStep {
  FORM = "form",
  SUMMARY = "summary", 
  VERIFICATION = "verification",
  SUCCESS = "success"
}

// State interface
interface ChargeMemberState {
  currentStep: ChargeMemberStep;
  requestAmount: number;
  requestTip: number;
  paymentData: PaymentSummaryData | null;
  otpPaymentId: string | null;
  successData: PaymentSuccessResponse | null;
  
  // Actions
  setStep: (step: ChargeMemberStep) => void;
  setPaymentData: (
    requestAmount: number,
    requestTip: number,
    paymentData: PaymentSummaryData
  ) => void;
  handleBack: () => void;
  handleRequestOtp: (otpPaymentId: string) => void;
  handleVerificationSuccess: (paymentData: PaymentSuccessResponse) => void;
  reset: () => void;
}

// Initial state
const initialState = {
  currentStep: ChargeMemberStep.FORM,
  requestAmount: 0,
  requestTip: 0,
  paymentData: null,
  otpPaymentId: null,
  successData: null,
};

// Create the store
export const useChargeMemberStore = create<ChargeMemberState>((set, get) => ({
  ...initialState,
  
  setStep: (step) => set({ currentStep: step }),
  
  setPaymentData: (requestAmount, requestTip, paymentData) => {
    set({
      requestAmount,
      requestTip,
      paymentData,
      currentStep: ChargeMemberStep.SUMMARY
    });
  },
  
  handleBack: () => {
    const { currentStep } = get();
    
    if (currentStep === ChargeMemberStep.SUMMARY) {
      set({
        currentStep: ChargeMemberStep.FORM,
        paymentData: null
      });
    } else if (currentStep === ChargeMemberStep.VERIFICATION) {
      set({ currentStep: ChargeMemberStep.SUMMARY });
    }
  },
  
  handleRequestOtp: (otpPaymentId) => {
    set({
      otpPaymentId,
      currentStep: ChargeMemberStep.VERIFICATION
    });
  },
  
  handleVerificationSuccess: (paymentData) => {
    set({
      successData: paymentData,
      currentStep: ChargeMemberStep.SUCCESS
    });
  },
  
  reset: () => {
    set(initialState);
  }
}));

// Register the store with the registry for global reset
storeRegistry.register(useChargeMemberStore); 